import { ComponentRef, Directive, effect, inject, Signal, Type, ViewContainerRef } from '@angular/core'

import { CmsBlock } from './cms-block'
import { UnknownBlockComponent } from './unknown/unknown-block.component'

type Mapping = {
  [key: string]: Type<CmsBlock<any>>
}
type BlockDataType<T extends Type<CmsBlock<any>>> = T extends Type<CmsBlock<infer U>> ? U : never

@Directive()
export abstract class DynamicInsert<T extends Mapping> {
  abstract readonly data: Signal<BlockDataType<T[keyof T]> | null>

  protected abstract readonly blockMapping: T

  private current: ComponentRef<CmsBlock<any>> | null = null

  private readonly container = inject(ViewContainerRef)

  constructor() {
    effect(() => this.createOrUpdateComponent(this.data()))
  }

  private createOrUpdateComponent(data: BlockDataType<T[keyof T]> | null): ComponentRef<CmsBlock<any>> | null {
    if (data) {
      const componentType: Type<CmsBlock<any>> = this.blockMapping[data.__typename] ?? UnknownBlockComponent

      let ref: ComponentRef<CmsBlock<BlockDataType<T[keyof T]>>>
      if (this.current?.componentType === componentType) {
        ref = this.current
      } else {
        this.container.clear()
        ref = this.container.createComponent(componentType)
      }
      ref.setInput('data' satisfies keyof CmsBlock<any>, data)
      return ref
    } else {
      this.container.clear()
      return null
    }
  }
}
